import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const Breadcrumbs = () => {
  return (
    <div className="sm:flex flex-row max-w-1200 mx-auto max-xl:px-4 hidden">
      <Breadcrumb className="breadcrumb-wrapper">
        <BreadcrumbItem>
          <Link to="/">
            <span>Home</span>
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/about-us">
            <span>About Us</span>
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <span>Careers</span>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
